import SmallHeadingComponent from "../component/SmallHeadingComponent"
import TextField from "../component/TextField"
import Link from "../component/Link"
import MoveContentToRight from "../component/MoveContentToRight"
import Button from "../component/Button"
import Card from "../component/Card"
import CenterContents from "../component/CenterContents"
import { useState } from "react"
import { useAppDispatch } from "../redux/store/hooks"
import { dispatchThunk } from "../redux/thunk/thunkify"
import { SignInProfessionalSpecification } from "pokal_api"
import { useNavigate, useLocation } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"

function SignInView() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const emailState = useState<string>("")
    const passwordState = useState<string>("")

    function signIn() {
        if (!signInEnabled()) return

        dispatchThunk(
            dispatch,
            SignInProfessionalSpecification,
            {
                email: emailState[0],
                password: passwordState[0]
            },
            {
                do: () => {
                    // Check if user was redirected and has a target page stored
                    const redirectTo = location.state?.from || NavigationPaths[NAVIGATION_VIEW.HOME].path
                    navigate(redirectTo)
                }
            }
        )

        // Clear input fields after sign-in attempt
        emailState[1]("")
        passwordState[1]("")
    }

    function signInEnabled(): boolean {
        return emailState[0] !== "" && passwordState[0] !== ""
    }

    return (
        <CenterContents>
            <Card>
                <div className="flex flex-col space-y-10">
                    <SmallHeadingComponent>Anmeldung</SmallHeadingComponent>
                    <TextField
                        inputState={emailState}
                        type="text"
                        placeholder="Emailadresse hier eingeben"
                        label="Emailadresse"
                    />
                    <TextField
                        onEnter={signIn}
                        inputState={passwordState}
                        type="password"
                        placeholder="Passwort hier eingeben"
                        label="Passwort"
                    >
                        <Link
                            href={
                                NavigationPaths[NAVIGATION_VIEW.PASSWORD_FORGOTTEN].path
                            }
                        >
                            Passwort vergessen?
                        </Link>
                    </TextField>
                    <MoveContentToRight>
                        <Button disabled={!signInEnabled()} onClick={signIn}>
                            Anmelden
                        </Button>
                    </MoveContentToRight>
                </div>
            </Card>
        </CenterContents>
    )
}

export default SignInView
